// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.r5KI4A9siCHJSrvga7LY{min-height:40px}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/inboxes/pages/id/pages/settings/messaging/businessHours/ui/CustomDayRow/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,eAAA","sourcesContent":[".dayRow {\n  min-height: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dayRow": `r5KI4A9siCHJSrvga7LY`
};
export default ___CSS_LOADER_EXPORT___;
